import { Component } from 'react';
import passed from '../../../../assets/img/performances/PASSED_GREEN@2x.png';

class PerformanceBar extends Component {
  hasReachedTarget() {
    const { data } = this.props;
    return data.packs_sold >= data.target;
  }

  hasReachedBaseTarget() {
    const { data } = this.props;
    return data.packs_sold >= data.base_target;
  }

  performanceBarBGColor() {
    if (this.hasReachedTarget()) {
      return '#70bd4d';
    }
    return '#5DBA5B';
  }

  performanceBaseTargetBarBGColor() {
    if (this.hasReachedBaseTarget()) {
      return '#70bd4d';
    }
    return '#5DBA5B';
  }

  incentiveIsBaseTarget = () => {
    const { data } = this.props;
    return data.kind === 'base_target';
  }

  render() {
    const { data } = this.props;
    const progress = Math.min(Math.floor((data.packs_sold / data.target) * 100), 100);
    const baseTargetProgress = this.incentiveIsBaseTarget() ?
      Math.min(Math.floor((data.base_target / data.target) * 100), 100) : 0;

    let fakeProgress = progress;
    let indicatorAlign = '0px';
    if (progress <= 2) {
      fakeProgress = 0;
    } else if (progress >= 3 && progress < 98) {
      indicatorAlign = '32px';
    } else if (progress >= 98) {
      fakeProgress = 100;
      indicatorAlign = '64px';
    }

    return (
      <div className="performance-bar-wrapper">
        <div className="sold-indicator" style={ { left: `calc(${fakeProgress}% - ${indicatorAlign})` } }>
          ACHIEVED
          <strong className="packs-sold">{data.packs_sold}</strong>
        </div>
        <div className="performance-bar-back"></div>
        <div className="performance-bar" style={ { backgroundColor: this.performanceBarBGColor() } }></div>
        {this.incentiveIsBaseTarget() && (
          <div
            className="performance-bar"
            style={ {
              left: 0,
              width: `${baseTargetProgress}%`,
              zIndex: 10,
              backgroundColor: this.performanceBaseTargetBarBGColor()
            } }
          >
          </div>
        )}
        <div
          className="performance-bar-overlay"
          style={{
            width: `${100 - progress}%`,
            borderTopLeftRadius: `${progress === 0 ? '15px' : '0px'}`,
            borderBottomLeftRadius: `${progress === 0 ? '15px' : '0px'}`
          }}
        />
        <div className="target-indicator">
          <div className="target-divider">
            <span className="target-divider-left"></span>
            <span className="target-divider-right"></span>
          </div>
          <div className="target-label">TARGET</div>
          <div className="target-value"><strong>{data.target}</strong></div>
        </div>
        {this.incentiveIsBaseTarget() && (
          <div className="target-indicator" style={ { left: `calc(${baseTargetProgress}% - 32px)` } }>
            <div className="target-divider">
              <span className="target-divider-left"></span>
              <span className="target-divider-right"></span>
            </div>
            <div className="target-label">TARGET</div>
            <div className="target-value">
              <strong>{data.base_target}</strong>
            </div>
          </div>
        )}
        {this.hasReachedTarget() && (
          <div className="green-tick">
            <div className="green-tick-image">
              <img src={passed} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PerformanceBar;
